<template>
  <div class="flex flex-col">
    <eezee-nav />
    <z-loading :active="isLoading" :is-full-page="false" />
    <div class="flex flex-col p-4">
      <p class="font-bold text-2xl whitespace-pre" :style="this.isEezeeTheme ? 'color: #4f4f4f' : 'color: #001136'">
        {{ $t('Review') }}
      </p>

      <!-- user info fields -->
      <div>
        <form class="flex flex-col gap-4.5 pt-4">
          <div class="relative h-16">
            <input
              type="text"
              :disabled="true"
              :value="$store.state.userInfo.fullName"
              class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary"
            />
            <label
              :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
              class="absolute top-2.5 text-xs font-semibold"
              >{{ $t('FullName') }}</label
            >
          </div>

          <div class="flex flex-row gap-3.5">
            <div class="relative h-16">
              <input
                type="text"
                :disabled="true"
                :value="$store.state.userInfo.nationality"
                class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
              <label
                :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
                class="absolute top-2.5 text-xs font-semibold"
                >{{ $t('Country') }}</label
              >
            </div>
            <div class="relative h-16">
              <input
                type="text"
                :disabled="true"
                :value="$store.state.userInfo.sex"
                class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
              <label
                :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
                class="absolute top-2.5 text-xs font-semibold"
                >{{ $t('Gender') }}</label
              >
            </div>
          </div>

          <div class="flex flex-row gap-3.5">
            <div class="relative h-16">
              <input
                type="text"
                :disabled="true"
                :value="$store.state.userInfo.dateOfBirth.day + '/' + $store.state.userInfo.dateOfBirth.month + '/' + $store.state.userInfo.dateOfBirth.year"
                class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
              <label
                :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
                class="absolute top-2.5 text-xs font-semibold"
                >{{ $t('DateOfBirth') }}</label
              >
            </div>
            <div class="relative h-16">
              <input
                type="text"
                :disabled="true"
                :value="$store.state.userInfo.dateOfExpiry.day + '/' + $store.state.userInfo.dateOfExpiry.month + '/' + $store.state.userInfo.dateOfExpiry.year"
                class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
              <label
                  :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
                class="absolute top-2.5 text-xs font-semibold"
                >{{ $t('ExpiryDate') }}</label
              >
            </div>
          </div>

          <div class="relative h-16">
            <input
              :required="true"
              type="email"
              :value="email"
              @input="event => changeEmail(event.target.value)"
              class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
            <label
              :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
              class="absolute top-2.5 text-xs font-semibold"
              >{{ $t('EmailAddress') }}*</label
            >
          </div>

          <div class="relative h-16" v-if="$store.state.userInfo.address">
            <input
              type="text"
              :disabled="true"
              :value="$store.state.userInfo.address"
              class="focus:outline-none focus:ring-primary px-4 pt-6 w-full h-full border text-gray-900 rounded-lg border-eezeeGray-light focus:border-primary" />
            <label
              :style="$i18n.locale === 'ar' ? this.isEezeeTheme ? 'right:16px; color: #b1b3b6' : 'right:16px; color: #001136' : this.isEezeeTheme ? 'left:16px; color: #b1b3b6' : 'left:16px; color: #001136'"
              class="absolute top-2.5 text-xs font-semibold"
              >{{ $t('Address') }}</label
            >
          </div>
          <button
            type="button"
            @click="activate"
            :disabled="this.buttonDisabled"
            class="w-full h-16 font-bold text-white"
            :style="this.isEezeeTheme ? 'border-radius: 8px; backgroundColor: #d12b8a' : 'border-radius: 9999px; backgroundColor: #DB0A40'">
            {{ $t('Confirm') }}
          </button>
        </form>
      </div>
    </div>
    <img
        v-if="!isEezeeTheme"
        src="../../assets/RedBullPatternWing.svg"
        alt="RedBull Pattern"
        class="absolute w-full -z-1 opacity-60"
        :style="$i18n.locale === 'ar' ? 'transform: scaleX(-1); top: 8%' : 'top: 8%'"
    />
  </div>
</template>

<script>
import EezeeNav from '@/components/eezee/EezeeNav.vue'
import ZLoading from '@/zain-component-library/src/lib-components/ZLoading.vue'

export default {
  name: 'ConfirmEezee',
  components: { ZLoading, EezeeNav },
  data() {
    return {
      isLoading: false,
      email: null,
      buttonDisabled: true,
      isEezeeTheme: this.$route.path.startsWith('/eezee')
    }
  },
  beforeCreate() {
    if (!this.$store.state.userInfo) {
      this.$router.push('/eezee')
    }
  },
  methods: {
    async activate() {
      this.isLoading = true
      const res = await this.$store.dispatch('submitScanPartner',  this.email)
      this.isLoading = false
      if(res === true) {
        await this.$router.push({name: 'SuccessEezee'})
      }
    },
    changeEmail(email) {
      this.email = email
      this.buttonDisabled = false
    }
  }
}
</script>

<style scoped></style>
